import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./footer.css";


const Footer = () => {
  const [ip, setIp] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then(res => res.json())
      .then(data => setIp(data.ip))
      .catch(() => setIp("Unavailable"));
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Column 1 */}
        <div className="footer-col">
          <h3 className="logo">FryumTech Solutions</h3>
          <p className="footer-vision">"Your Growth, Our Success"</p>

          {/* ✅ IP INFO ADDED */}
          <p className="service-status">
            <span className="status-dot"></span>
            All services are online
          </p>
          <p className="ip-text">
            Your IP Address {ip}
          </p>
        </div>
        {/* Column 2 */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/#hero">Home</a></li>
            <li><Link to="/serviceSection">Service</Link></li>
            <li><Link to="/project">Project</Link></li>
            <li><Link to="/team">Team</Link></li>
            <li><Link to="/contactSection">Contact</Link></li>
          </ul>
        </div>

        {/* Column 3 */}
        <div className="footer-col">
          <h4>Our Policies</h4>
          <ul>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/cancellation">Cancellation Policy</Link></li>
            <li><Link to="/refund">Refund Policy</Link></li>
          </ul>
        </div>

        {/* Column 4 */}
        <div className="footer-col">
          <h4>Contact</h4>
          <p>Feel free to Contact us.</p>
          <p>
            <a href="tel:+916306642178" className="contact-link phone-link">
              +91 63066 42178
            </a>
          </p>
          <p>
            <a
              href="mailto:fryumtechsolutions@gmail.com?subject=Contact%20Inquiry&body=Hello%20Team,"
              className="contact-link email-link"
            >
              fryumtechsolutions@gmail.com
            </a>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © 2026 <strong>FryumTech Solutions</strong>. All Rights Reserved.
        </p>
        <p className="footer-note">
          We may display visitor IP addresses for security and transparency purposes.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
